import type { MouseEvent, ReactNode } from 'react';

import { type Route, routeToPath } from './routing.ts';

export interface RouteLinkProps {
  to: Route;
  /** The app's own navigation, which a plain click goes through instead of a page load. */
  onNavigate: (route: Route) => void;
  testId: string;
  children: ReactNode;
}

/**
 * A link to one of the app's screens: a real `href`, so it can be opened in a new tab or copied,
 * and an in-app move for the plain click that would otherwise reload the whole bundle.
 */
export const RouteLink = ({ to, onNavigate, testId, children }: RouteLinkProps) => (
  <a
    href={routeToPath(to)}
    data-test-id={testId}
    onClick={(event: MouseEvent<HTMLAnchorElement>) => {
      // A modified or middle click is the browser's to handle: it means a new tab or window.
      if (event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) {
        return;
      }

      event.preventDefault();
      onNavigate(to);
    }}
  >
    {children}
  </a>
);
